export default "__VITE_ASSET__31e7bbba__"